// Pure helpers for Android share-to-Heldall (v1). No side effects, no persistence.
// Routing is review-first by construction: every share is handed to the existing TalkItThrough
// review flow — these helpers only decide which capture pipeline and what combined text/source.
export const SHARE_CACHE = "heldall-share";
export const SHARE_TTL_MS = 5 * 60 * 1000;

// Title + text + URL combined into one clean stream for the text pipeline (de-duped url==text).
export function combinedShareText(meta) {
  if (!meta) return "";
  const parts = [];
  if (meta.title) parts.push(String(meta.title).trim());
  if (meta.text) parts.push(String(meta.text).trim());
  const url = (meta.url || "").trim();
  if (url && url !== (meta.text || "").trim()) parts.push(url);
  return parts.filter(Boolean).join("\n").trim();
}

// Decide the review routing for a received payload.
//  - disabled (kill switch off) -> no processing.
//  - image present  -> image pipeline (POST /api/capture/image); accompanying text/url is NOT
//    sent as context in v1 (backend image endpoint does not accept it) -> droppedContext=true.
//  - text/url only  -> text pipeline (POST /api/capture/talk) with combined text.
//  - nothing usable -> empty.
// Always source="share"; never a save action (review-first).
export function shareRouteOf(meta, hasFile, enabled = true) {
  if (!enabled) return { kind: "disabled", pipeline: null, source: "share", action: "none" };
  if (hasFile) {
    const hadContext = !!(meta && (String(meta.text || "").trim() || String(meta.url || "").trim()));
    return { kind: "image", pipeline: "image", source: "share", droppedContext: hadContext, action: "review" };
  }
  const text = combinedShareText(meta);
  if (!text) return { kind: "empty", pipeline: null, source: "share", action: "none" };
  return { kind: "text", pipeline: "talk", source: "share", text, action: "review" };
}
